<template>
    <div
        class="node"
        :class="{
            'vertical':   node.vertical > 0,
            'horizontal': node.vertical < 1,
            'container':  typeof node.wn == 'undefined',
            'central':    node.order <= 0,
            'board':      typeof node.wn !== 'undefined',
            'draggable':  typeof node.wn !== 'undefined' && typeof node.meta !== 'undefined' && node.meta.draggable,
            'short':      typeof node.wn !== 'undefined' && typeof node.meta !== 'undefined' && node.meta.isShort,
            'zero':       node.len <= 0,
            'round':      typeof node.cylinder !== 'undefined' && node.cylinder == 1
        }"
        :style="style"
        :draggable="typeof node.wn !== 'undefined' && typeof node.meta !== 'undefined' && node.meta.draggable"
        :data-index="typeof node.meta !== 'undefined' && typeof node.meta.index !== 'undefined' ? node.meta.index : -1"
        v-if="typeof node.meta == 'undefined' || (typeof node.meta !== 'undefined' && node.meta.isBoard) || (typeof node.meta !== 'undefined' && !node.meta.isBoard && node.items.length > 0)"
    >
        <span
            class="label"
            :style="lblStyle"
            v-if="node.tn"
        >
                <template v-if="typeof node.cylinder !== 'undefined' && node.cylinder == 1"> &Oslash; {{ node.tn }} </template>
                <template v-if="typeof node.cylinder == 'undefined' && showNominal"> {{ node.tn }} x {{ node.wn }} </template>
                <template v-if="typeof node.cylinder == 'undefined' && !showNominal"> {{ node.ts.toFixed(1) }} x {{ node.ws.toFixed(1) }} </template>
                <template v-if="(typeof node.len !== 'undefined')"> x {{ node.len.toFixed(1) }}</template>
                <template v-if="(typeof node.waneLen !== 'undefined' && node.waneLen > 0)">({{ node.waneLen.toFixed(1) }})</template>
        </span>

        <pattern-vue-node
            v-for="(item, index) in node.items"
            :node="item"
            :showNominal="showNominal"
            :key="index"
        />


    </div>
</template>

<script>
    export default {
        name:  "PatternVueNode",

        props: [ "node", "showNominal" ],

        data () {
            return {
                style: {}
            }
        },

        mounted () {
            this.style = !this.node.meta ? {} : this.node.meta.style;
        },

        watch: {
            node: {
                handler: function () {
                    this.style = !this.node.meta ? {} : this.node.meta.style;
                },
                deep: true
            }
        },

        computed: {
            lblStyle: function () {
                return !this.node.meta ? {} : this.node.meta.lblStyle;
            },
            /*
            style: function () {
                return !this.node.meta ? {} : this.node.meta.style;
            }
            */
        },
    }
</script>

<style lang="sass" scoped>
    .node.vertical.container:empty
        display: none
</style>
